import type { ReactNode } from 'react';
import { getLocationBadgeStyles } from '@/lib/utils/locationColor';
import { cn } from '@/lib/utils';

interface LocationColorBadgeProps {
  colorCode: string | null | undefined;
  children: ReactNode;
  className?: string;
}

export function LocationColorBadge({ colorCode, children, className }: LocationColorBadgeProps) {
  return (
    <span
      className={cn('inline-flex items-center rounded-md px-2 py-0.5', className)}
      style={getLocationBadgeStyles(colorCode)}
    >
      {children}
    </span>
  );
}
